/* eslint-disable @typescript-eslint/no-explicit-any */
import { Languages } from '@/constants'
import { useAuth, useStore } from '@/containers'
import { CouponArrowDown, CouponIconSimple } from '@/styles/Icon'
import { useState } from 'react'
import ModalVoucherList from '../Popup/ModalVoucherList'
import FormRadioButtonItems from './FormRadioButtonItems'

interface FormDiscount {
  className?: string
  onClick?: () => void
  icon?: boolean
  disabled?: boolean
  isError?: boolean | string
  type?: 'button' | 'submit' | 'reset' | undefined
  typeButtonPrimary?: 'button' | 'submit' | 'reset' | undefined
  classButtonConfirm?: string
  id?: string
  name?: string
  value?: string
  primary?: boolean
  secondary?: boolean
  // onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  placeholder: string
  buttonPlaceholder: string
  buttonText: string
  shippingMethod?: string
  discount?: number
}

const FormDiscount = ({ shippingMethod, discount = 0 }: FormDiscount) => {
  const { selectedLang } = useStore()

  const { errorAuth, cart } = useAuth()

  const [showListCoupons, setShowListCoupons] = useState(false)

  const currency = (lang: string) => {
    switch (lang) {
      case 'vi':
        return 'VND'
      case 'en':
        return 'USD'
      default:
        return 'VND'
    }
  }

  return (
    <div className='discountBox bg-grey-200 rounded py-2' id='voucher'>
      <div
        className='relative mb-2 flex h-12 w-full cursor-pointer flex-row items-center rounded-lg border border-gray-100 bg-white'
        onClick={() => setShowListCoupons(true)}
      >
        <span className='icon mx-[15px]'>
          <CouponIconSimple />
        </span>
        <span className='text-Headline leading-none tracking-tight'>
          Sử dụng mã giảm giá
        </span>
        <CouponArrowDown className='absolute right-[15px] top-[35%]' />
      </div>
      {cart?.coupons?.filter(e => e.mes).length > 0 && (
        <div className='mb-1 w-full text-base font-normal italic leading-tight text-primary-second opacity-80'>
          Một trong số các voucher không hợp lệ, tiếp tục mua hàng mà không cần
          voucher đó
        </div>
      )}
      {discount && discount > 0 ? (
        <div className='mb-1 text-dark-400'>
          Đã áp dụng <strong>{cart.coupons.filter(e => !e.mes).length}</strong>{' '}
          mã (giảm{' '}
          <strong className='font-bold text-primary-second'>
            {discount
              ?.toLocaleString(selectedLang as string, {
                style: 'currency',
                currency: currency(selectedLang as string),
              })
              .replace(/\s₫/g, 'đ')}
          </strong>
          )
        </div>
      ) : (
        ''
      )}
      <div className='w-full overflow-y-auto'>
        <FormRadioButtonItems className='flex flex-wrap !gap-2 pb-1'>
          {!errorAuth?.status &&
            cart?.coupons &&
            cart.coupons
              .filter(e => !e.mes)
              .map((e, i) => {
                return (
                  <div
                    key={i}
                    className='voucherItem bg-fill flex h-[34px] w-full max-w-[113px] items-center justify-center bg-[url("/assets/icons/couponBg.svg")] bg-center bg-no-repeat'
                  >
                    <span className='flex h-full w-full items-center justify-center self-center text-center text-[10px] text-primary-second'>
                      Giảm{' '}
                      {e.value
                        .toLocaleString(Languages.VN, {
                          style: 'currency',
                          currency: 'VND',
                        })
                        .replace(/\s₫/g, 'đ')}
                    </span>
                  </div>
                )
              })}
        </FormRadioButtonItems>
        <ModalVoucherList
          showListCoupons={showListCoupons}
          setShowListCoupons={setShowListCoupons}
          shippingMethod={shippingMethod}
        />
      </div>
    </div>
  )
}

export default FormDiscount
